import React from 'react';
import { Container, Button, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

// ✅ Styled Components for UI
const StyledContainer = styled(Container)`
  background-color: #232830;
  color: #FFFFFF;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
`;

const QuoteCard = styled(Card)`
  background-color: #1E1E1E;
  color: #FFFFFF;
  border-radius: 15px;
  padding: 20px;
  margin-bottom: 20px;
  width: 100%;
  max-width: 500px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
`;

const ContinueButton = styled(Button)`
  background-color: #FF7C24;
  border-color: #FF7C24;
  font-size: 18px;
  font-weight: bold;
  border-radius: 10px;
  padding: 12px 30px;
  width: 100%;
  max-width: 300px;
  margin-top: 20px;
`;

const PostActivationQuotePage = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate('/post-activation-coins-earned');
  };

  return (
    <StyledContainer>
      {/* ✅ Motivational Quote */}
      <QuoteCard>
        <p>"The stock market is filled with individuals who know the price of everything, but the value of nothing." – Philip Fisher</p>
      </QuoteCard>

      {/* ✅ Continue Button */}
      <ContinueButton onClick={handleContinue}>Continue</ContinueButton>
    </StyledContainer>
  );
};

export default PostActivationQuotePage;
